import { render, staticRenderFns } from "./arrears.vue?vue&type=template&id=24daac7d&scoped=true"
import script from "./arrears.vue?vue&type=script&lang=js"
export * from "./arrears.vue?vue&type=script&lang=js"
import style0 from "./arrears.vue?vue&type=style&index=0&id=24daac7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24daac7d",
  null
  
)

export default component.exports